import { MdLogout } from "react-icons/md";

const LogoutIcon = (props) => {
    return <MdLogout className={props.className} />
}

export default LogoutIcon;